module.exports = __webpack_public_path__ + "static/img/zfb.1dccf954.svg";